import {
  ApplicationRef,
  createComponent,
  EnvironmentInjector,
  Injectable,
  signal,
} from '@angular/core';
import {
  SbiToast,
  SbiToastType,
} from '../../components/sbi-toast/sbi-toast.model';
import { SbiToastContainerComponent } from '../../components/sbi-toast/sbi-toast-container/sbi-toast-container.component';

@Injectable({ providedIn: 'root' })
export class SbiToastService {
  readonly toasts = signal<SbiToast[]>([]);

  constructor(appRef: ApplicationRef, injector: EnvironmentInjector) {
    // Defer to next tick so DI finishes resolving this service before
    // SbiToastContainerComponent tries to inject it back
    setTimeout(() => {
      const containerRef = createComponent(SbiToastContainerComponent, {
        environmentInjector: injector,
      });
      appRef.attachView(containerRef.hostView);
      document.body.appendChild(containerRef.location.nativeElement);
    });
  }

  success(message: string, duration = 5000): void {
    this._push('success', message, duration);
  }

  error(message: string, duration = 5000): void {
    this._push('error', message, duration);
  }

  warning(message: string, duration = 5000): void {
    this._push('warning', message, duration);
  }

  info(message: string, duration = 5000): void {
    this._push('info', message, duration);
  }

  dismiss(id: string): void {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  clear(): void {
    this.toasts.set([]);
  }

  private _push(type: SbiToastType, message: string, duration: number): void {
    this.toasts.update(list => [
      ...list,
      { id: crypto.randomUUID(), type, message, duration },
    ]);
  }
}
